import React from "react";
import { Link } from "react-router-dom";
import profileImg from "../images/profile-image-3.png";
import data from "../data/data";

const Home = () => {
  const bio = [...data.bioInfo];
  const socialLinks = [...data.socialLinks];

  return (
    <div className="page-height">
      <div className="home">
        <div className="row">
          <div className="home-info">
            <p className="title-info">Get every single solutions</p>
            <p className="title-info">Hello everybody, I am</p>
            <p className="title">
              <span>Sheldon Welinga</span>
              <span>Web Developer</span>
              <span>&amp; Designer</span>
            </p>
            <p className="content">
              With your project in my hands, you will begin to realise why
              designing and developing websites became my renowned career.
              Offering upto the best content designs with modern Framworks like
              Reactjs, Nodejs and design tools like Figma. Leave your project
              with me today and be assured of quality.
            </p>
            {bio.map((item) => (
              <p className="bio-info" key={item.id}>
                <i className={item["logo-class"]}></i>
                <span>{item.content}</span>
              </p>
            ))}
            <div className="social-icons">
              {socialLinks.map((item) => (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={item.id}
                >
                  <i className={item["icon-class"]} />
                </a>
              ))}
            </div>
            <div className="button-holder">
              <Link to="/about">
                <button className="btn btn-primary">Learn More</button>
              </Link>
              <Link to="/contact">
                <button className="btn btn-primary-outline">Hire Me</button>
              </Link>
            </div>
          </div>
          <div className="profile-info">
            <img src={profileImg} alt="sheldon welinga" className="img-fluid" />
          </div>
        </div>
      </div>
      <div className="home-section-two">
        <div className="section-caption">
          <h2>
            Developing upto standard websites and Designing with passion while
            exploring the world.
          </h2>
          <p>
            I deliver quality websites and upto standards within a set
            timelines. My experience with web delepoment has seen me grow from
            just being a Front End developer to also being a backend developer
            and designer.
          </p>
          <p>
            I invest much of my time doing research on what is on the market so
            as to come up with the best designs my customers can get. Be assured
            that you've got the right person for your job.
          </p>
        </div>
        <div className="section-caption">
          <h2>Any type of queries and discussion?</h2>
          <p>Talk to me today</p>
          <p className="email">sheldonwelinga@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
